<div
	class="customer-information-container"
	*ngIf="!isLoadingLabels && !isLoadingCustomerForm && !isLoadingContractedGroup && !isLoadingCustomerPermissions">
	<div class="content-col-header">
		<span class="tab" [ngClass]="{ selected: selectedTab === 'infoCustomer' }" (click)="selectedTab = 'infoCustomer'">{{
			labels.lbl_chamado_informacoes_gerais
		}}</span>
		<span
			class="tab"
			[ngClass]="{ selected: selectedTab === 'contractedSolutionAreas' }"
			(click)="selectedTab = 'contractedSolutionAreas'"
			>{{ labels.lbl_grupos_reabertura_chamado }}</span
		>
		<span class="tab" [ngClass]="{ selected: selectedTab === 'customerPermission' }" (click)="selectedTab = 'customerPermission'">{{
			labels.lbl_cadastro_permissoes
		}}</span>
	</div>

	<div class="content-col" [ngStyle]="{ display: selectedTab === 'infoCustomer' ? 'block' : 'none' }">
		<ng-container>
			<cpi-generic-form-gen [setGenericForm]="customerForm" [columns]="1" [labels]="labels" [triggerRequired]="triggerRequired">
			</cpi-generic-form-gen>

			<div class="button-container">
				<div class="button" [ngClass]="{ disabled: isUpdatingCustomer }" (click)="updateCustomer()">
					{{ labels.lbl_geral_atualizar }}
					<cpi-dot-bounce-loading-effect
						[color]="'var(--const-white)'"
						*ngIf="isUpdatingCustomer"></cpi-dot-bounce-loading-effect>
				</div>
			</div>
		</ng-container>
	</div>

	<div class="content-col" [ngStyle]="{ display: selectedTab === 'contractedSolutionAreas' ? 'block' : 'none' }">
		<ng-container>
			<cpi-msp-table
				[header]="searchHeader"
				[body]="contractedGroupList"
				[height]="'55dvh'"
				[itemPadding]="'1%'"
				[labels]="labels"
				[insideSort]="true"
				(getSelectedItem)="updateContractedGroup($event)">
			</cpi-msp-table>
		</ng-container>
	</div>

	<div class="content-col" [ngStyle]="{ display: selectedTab === 'customerPermission' ? 'block' : 'none' }">
		<div class="permission-container">
			<div class="line">
				<div class="header">
					<input
						[placeholder]="labels.lbl_cadastro_permissoes"
						[value]="permissionSort.filterPermission"
						(input)="permissionSort.filterPermission = $event.target.value" />
					<span
						[ngClass]="{ selected: permissionSort.sortName === 'permission' }"
						(click)="
							permissionSort.sortName === 'permission'
								? (permissionSort.sortOrder[0] = !permissionSort.sortOrder[0])
								: (permissionSort.sortName = 'permission');
							sortPermissions()
						">
						<fa-icon [ngClass]="{ sortUp: permissionSort.sortOrder[0] }" [icon]="icons.faSortDown"></fa-icon>
					</span>
				</div>
				<div class="header">
					<input
						[placeholder]="labels.lbl_geral_descricao"
						[value]="permissionSort.filterDescription"
						(input)="permissionSort.filterDescription = $event.target.value" />
					<span
						[ngClass]="{ selected: permissionSort.sortName === 'description' }"
						(click)="
							permissionSort.sortName === 'description'
								? (permissionSort.sortOrder[1] = !permissionSort.sortOrder[1])
								: (permissionSort.sortName = 'description');
							sortPermissions()
						">
						<fa-icon [ngClass]="{ sortUp: permissionSort.sortOrder[1] }" [icon]="icons.faSortDown"></fa-icon>
					</span>
				</div>
				<div class="header">
					<span>{{ labels.lbl_geral_ativo }}</span>
					<span
						[ngClass]="{ selected: permissionSort.sortName === 'active' }"
						(click)="
							permissionSort.sortName === 'active'
								? (permissionSort.sortOrder[2] = !permissionSort.sortOrder[2])
								: (permissionSort.sortName = 'active');
							sortPermissions()
						">
						<fa-icon [ngClass]="{ sortUp: permissionSort.sortOrder[2] }" [icon]="icons.faSortDown"></fa-icon>
					</span>
				</div>
			</div>
			<div
				class="line"
				(click)="permission.allowed == 1 ? (permission.allowed = 0) : (permission.allowed = 1)"
				*ngFor="let permission of customerPermissions | callback: permissionFilterCallback">
				<span [title]="permission.permission">{{ permission.permission }}</span>
				<span [title]="permission.description">{{ permission.description }}</span>
				<span><fa-icon [icon]="permission.allowed == true ? icons.faCheckSquare : icons.faSquare"></fa-icon></span>
			</div>

			<div class="button-container">
				<div class="button" [ngClass]="{ disabled: isUpdatingPermissions }" (click)="updateCustomerPermission()">
					{{ labels.lbl_geral_atualizar }} {{ labels.lbl_cadastro_permissoes }}
					<cpi-dot-bounce-loading-effect
						[color]="'var(--const-white)'"
						*ngIf="isUpdatingPermissions"></cpi-dot-bounce-loading-effect>
				</div>
			</div>
		</div>
	</div>
</div>

<cpi-dot-bounce-loading-effect
	[color]="'var(--primary-color-1)'"
	*ngIf="
		isLoadingLabels || isLoadingCustomerForm || isLoadingContractedGroup || isLoadingCustomerPermissions
	"></cpi-dot-bounce-loading-effect>
